import dayjs from "dayjs";

// utils/dateUtils.ts
export function parseDate(dateStr: string | null): Date | null {
  if (!dateStr) return null;

  const clean = dateStr.replace(/(^")|("$)/g, "").trim();
  const [day, month, year] = clean.split("-").map(Number);
  if (!day || !month || !year) return null;

  return new Date(year, month - 1, day);
}

export function validateDates(
  startStr: string | null,
  endStr: string | null,
  setErrorApi: (value: boolean) => void,
) {
  const startDate = parseDate(startStr);
  const endDate = parseDate(endStr);

  // se alguma das datas for inválida, marca erro
  if (!startDate || !endDate) {
    setErrorApi(true);
    return;
  }

  // erro verdadeiro se endDate for menor que startDate
  setErrorApi(endDate < startDate);
}

export const getDateRange = (
  startDate?: string,
  endDate?: string,
  monthsPeriod: number = 6,
): { initDate: string; finalDate: string } => {
  let initDate;
  let finalDate;

  if (!startDate || !endDate) {
    finalDate = dayjs().endOf("day");
    initDate = dayjs().subtract(monthsPeriod, "month").startOf("day");
  } else {
    initDate = dayjs(startDate, "DD-MM-YYYY").startOf("day");
    finalDate = dayjs(endDate, "DD-MM-YYYY").endOf("day");
  }

  return {
    initDate: initDate.format("YYYY-MM-DDTHH:mm:ss.SSS"),
    finalDate: finalDate.format("YYYY-MM-DDTHH:mm:ss.SSS"),
  };
};

export const getCurrentMonthRange = (): {
  startDate: string;
  endDate: string;
} => {
  const today = dayjs();

  return {
    startDate: today.startOf("month").format("YYYY-MM-DD"),
    endDate: today.endOf("month").format("YYYY-MM-DD"),
  };
};

export const toApiDate = (date?: string): string => {
  if (!date) return "";

  const [day, month, year] = date.replaceAll("/", "-").split("-");

  if (!day || !month || !year) return "";

  return `${year}-${month}-${day}`;
};

export const validateDateRange = (
  from: string,
  to: string,
  maxRangeMonths?: number,
): string => {
  const regex = /^\d{2}[/-]\d{2}[/-]\d{4}$/;

  if (!!from !== !!to) {
    return "Selecione a data inicial e final.";
  }

  if (!regex.test(from) || !regex.test(to)) {
    return "";
  }

  const normalizedFrom = from.replaceAll("/", "-");
  const normalizedTo = to.replaceAll("/", "-");

  const [fd, fm, fy] = normalizedFrom.split("-").map(Number);
  const [td, tm, ty] = normalizedTo.split("-").map(Number);

  const start = new Date(fy, fm - 1, fd);
  const end = new Date(ty, tm - 1, td);
  const today = new Date();

  if (start > end) {
    return "Data inicial não pode ser maior que a final.";
  }

  if (start > today || end > today) {
    return "Não é permitido selecionar datas futuras.";
  }

  if (maxRangeMonths !== undefined) {
    const maxRangeDate = new Date(start);
    maxRangeDate.setMonth(maxRangeDate.getMonth() + maxRangeMonths);

    if (end > maxRangeDate) {
      const monthLabel = maxRangeMonths === 1 ? "mês" : "meses";
      return `O intervalo máximo permitido é de ${maxRangeMonths} ${monthLabel}.`;
    }
  }

  return "";
};